import { IInfinitePageParams } from 'services/types';

export interface IMessageThreadId {
  messageThreadId: string;
}
export interface IMessageBase {
  message: string;
  attachments: File[];
  recipientId: string;
}
export interface ICreateThread extends IMessageBase {
  subject: string;
}
export interface ICreateMessage extends IMessageBase {
  threadId: string;
}

export interface IReadMessage {
  accountId?: string;
  messageId: string;
}

export interface IChatMessageAttachment {
  id: string;
  fileName: string;
  path: string;
  sizeInMB: number;
  createdAt: string;
  extension: string;
  mD5Hash: string;
}

export interface IChatMessage extends IMessageThreadId {
  id: string;
  senderId: string;
  recipientId: string;
  body: string;
  attachments: IChatMessageAttachment[];
  readAt: string | null;
  messageCreatedAt: string;
}

export interface IChat extends IMessageThreadId {
  labelName: string;
  labelId: string;
  subject: string;
  messages: IChatMessage[];
  messageThreadCreatedAt: string;
  hasUnreadMessage: boolean;
  messageThreadStatus: { id: THREAD_STATUS };
  lastMessage: IChatMessage;
}

export interface IChatMessagesSearchParams
  extends IInfinitePageParams, IMessageThreadId {}

export interface IChatThreadSearchParams extends IInfinitePageParams {
  labelId?: string;
}

export interface ICloseThread extends IMessageThreadId {}

export enum THREAD_STATUS {
  open = 1,
  closed = 2,
}
